/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
// Public API for render
var api_1 = require('./render/api');
exports.RenderComponentType = api_1.RenderComponentType;
exports.Renderer = api_1.Renderer;
exports.RootRenderer = api_1.RootRenderer;
//# sourceMappingURL=render.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular/core/src/render.js
 ** module id = 84
 ** module chunks = 3
 **/